import { z } from "zod"

export const SetMessageIsReadStatusSchema = z.object({
  id: z.string().uuid(),
  jobId: z.string().uuid(),
  isRead: z.boolean(),
  isManuallyUnread: z.boolean(),
})

export type SetMessageIsReadStatus = z.infer<
  typeof SetMessageIsReadStatusSchema
>

export const SetStoreCustomerMessageIsReadStatusSchema = z.object({
  isRead: z.boolean(),
  isManuallyUnread: z.boolean(),
})

export type SetStoreCustomerMessageIsReadStatus = z.infer<
  typeof SetStoreCustomerMessageIsReadStatusSchema
>
